import React, { useEffect, useState } from "react";
import { orderBy, sortBy } from "lodash";
import { getSpecialitiesWithSpecialistProfiles } from "../../services/specialists";
import { STATUS } from "../../constants";
import SpecialistProfileBox from "./SpecialistProfileBox";
import SelectField from "../Shared/SelectField";
import { newOrReviewOptions } from "../constant";
import Loading from "../Shared/Loading";
import "./index.css";

const Specialists = () => {
  const [specialities, setSpecialities] = useState([]);
  const [selectedSpecialities, setSelectedSpecialities] = useState(null);
  const [newOrReview, setNewOrReview] = useState("NEW");
  const [isLoading, setIsLoading] = useState(false);

  const fetchSpecialities = async () => {
    setIsLoading(true);
    const { data, status } = await getSpecialitiesWithSpecialistProfiles();
    if (status === STATUS.SUCCEED) {
      const sortedSpecialities = sortBy(data, ["name"]);
      setSpecialities(sortedSpecialities);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchSpecialities();
  }, []);

  const handleSelectSpeciality = (speciality) => () => {
    setSelectedSpecialities(speciality);
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="columns remove-margin is-size-7">
      <div className="column is-one-quarter has-background-info-light">
        <ul className="menu-list">
          {specialities?.map((speciality) => {
            const { id, name } = speciality;
            return (
              <li
                key={id}
                className={`speciality-item ${id === selectedSpecialities?.id ? "is-selected" : ""}`}
                onClick={handleSelectSpeciality(speciality)}
              >
                {name}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="column is-three-quarters">
        <div className="select-container">
          <SelectField
            label="NEW or Review"
            value={newOrReview}
            onChange={(e) => setNewOrReview(e.target.value)}
            options={newOrReviewOptions}
          />
        </div>
        {selectedSpecialities?.specialistProfiles.length > 0 &&
          orderBy(selectedSpecialities.specialistProfiles, ["firstName"], ["asc"]).map((specialist) => (
            <SpecialistProfileBox specialist={specialist} newOrReview={newOrReview} key={specialist.id} />
          ))}
      </div>
    </div>
  );
};

export default Specialists;
